import React, { useEffect } from 'react';

const APP_NAME = 'PowerZap by Kory - WhatsApp for Bitrix24';

export function PrivacyPage() {
	useEffect(() => {
		document.title = `Privacy Policy - ${APP_NAME}`;
		return () => {
			document.title = 'API Whatsapp Integration';
		};
	}, []);

	return (
		<div style={{ maxWidth: 900, margin: '0 auto', padding: '40px 24px' }}>
			<h1>{APP_NAME} Privacy Policy</h1>

			<p>
				Please read this Agreement carefully before accessing or using our Services. By accessing or
				using any part of our services, you agree to be bound by the terms and conditions of this
				agreement. If you do not agree to all the terms and conditions of this agreement, you may
				not access or use any of our services. If these terms and conditions are considered an offer
				by {APP_NAME}, acceptance will be expressly limited to these policies.
			</p>
			<p>
				{APP_NAME} respects the privacy of its website users and guarantees that the personal
				information you provide will be treated confidentially.
			</p>
			<p>
				We use your data to process orders as quickly and easily as possible. Furthermore, we will
				only use your data with your permission. The {APP_NAME} will not sell your personal
				information to third parties and will only share information with third parties that is
				strictly necessary for processing your service order.
			</p>

			<h2>Data collected</h2>
			<p>
				The {APP_NAME} uses the collected data to provide its clients with the following services:
			</p>
			<p>
				To make browsing the {APP_NAME} website as pleasant as possible, we save your information
				and personal data (with your permission) about your browsing habits and use of our services.
				This allows us to personalize the website and provide targeted offers and recommendations
				that you may find interesting.
			</p>
			<p>
				With your permission, we use your data to inform you about website developments, special
				offers, and promotions. If you no longer wish to receive this information, please let us
				know by sending an WhatsApp{' '}
				<a
					href="https://api.whatsapp.com/send/?phone=554833809953&text=Ol%C3%A1%21+Preciso+de+ajuda.&type=phone_number&app_absent=0"
					target="_blank"
					rel="noopener noreferrer"
				>
					+55 (48) 33809953
				</a>
				.
			</p>
			<p>
				If you create an account on {APP_NAME}, we will save your data on a secure server. In your{' '}
				{APP_NAME} account, we save information such as your name and address, phone number, email
				address, delivery and payment information, so you don't have to fill in your information
				every time you visit.
			</p>
			<p>
				The data about the use of our website and the feedback we receive from our visitors help us
				improve our site and further develop and enhance our service.
			</p>
			<p>
				Promotions from {APP_NAME} may require your personal data, such as name, address, and email
				address. We use this information to carry out our marketing and promotional efforts.
			</p>
			<p>
				The {APP_NAME} uses all the features of Google Analytics for Display Network advertisers. We
				obtain specific cookie data, such as source, medium, and keyword used to visit our website.
			</p>
			<p>
				Use Ad Settings to disable Google Analytics for display advertising and customize your
				Google Display Network ads.
			</p>
			<p>The {APP_NAME} uses remarketing with Google Analytics to advertise online.</p>
			<p>
				Third-party vendors, including Google, may display {APP_NAME} advertisements on websites
				across the Internet.
			</p>
			<p>
				{APP_NAME} and third-party vendors, including Google, use first-party cookies (such as the
				Google Analytics cookie) and third-party cookies (such as the DoubleClick cookie) together
				to inform, optimize, and serve ads based on your past visits to the website.
			</p>
			<p>
				The {APP_NAME} and third-party vendors, including Google, use first-party cookies (such as
				Google Analytics cookies) and third-party cookies (such as the DoubleClick cookie) together
				to report how impressions of your ad and other uses of ad services and interactions with
				those ad impressions and services relate to website visits.
			</p>
			<p>
				The {APP_NAME} will not sell your personal information to third parties and will only
				communicate with third parties involved in the execution of your application. Our employees
				and third parties are obligated to protect the confidentiality of your personal information.
			</p>
			<p>
				Your personal information is safe with the {APP_NAME}. We appreciate the trust you place in
				us and we will take great care with your data. When you place an order or access your{' '}
				{APP_NAME} account, Transport Layer Security (TLS v1.2 or higher) technology protects your
				data on the Internet. Your data will always be protected and kept confidential.
			</p>

			<h2>Cookies</h2>
			<p>
				Cookies are small pieces of information that your browser saves on your computer. {APP_NAME}{' '}
				uses cookies to recognize you on your next visit. Cookies allow us to collect information
				about the use of our services and to improve and adapt to the needs of our visitors. Our
				cookies provide information related to personal identification. You can configure your
				browser to be able to visit {APP_NAME} without receiving cookies.
			</p>
			<p>
				If you have any questions about the {APP_NAME} Privacy Policy, please WhatsApp{' '}
				<a
					href="https://api.whatsapp.com/send/?phone=554833809953&text=Ol%C3%A1%21+Preciso+de+ajuda.&type=phone_number&app_absent=0"
					target="_blank"
					rel="noopener noreferrer"
				>
					+55 (48) 33809953
				</a>
				. Our customer service will assist you if you need information about your data or wish to
				change it. If a change to our privacy policy is necessary, you will find the most up-to-date
				information on this page.
			</p>

			<h2>Data processing policy and GDPR</h2>
			<p>
				For data processing policy and GDPR regulations, please refer to the Data Processing
				Addendum document.
			</p>

			<h2>Changes</h2>
			<p>
				We reserve the right to update our privacy policy and data processing policy over time, and
				this means that we sometimes need to change the legal terms under which our Services are
				offered.
			</p>
			<p>
				If you do not agree with our changes, you must stop using our Services within the designated
				notice period. Your continued use of our services will be subject to the new terms. However,
				any dispute arising before the changes will be governed by this Policy (including the
				binding individual arbitration clause).
			</p>
		</div>
	);
}
